import * as T from './news.types';

const initial = {
  items: [],
  nextCursor: null,
  loading: false,
  error: null,
  filters: { q:'', tag:'', pinnedOnly:false, unreadOnly:false },
};

const mergeUniqueById = (a, b) => {
  const seen = new Set(); const out = [];
  for (const x of [...a, ...b]) {
    const id = String(x?._id || x?.id || '');
    if (!id) continue;
    if (!seen.has(id)) { seen.add(id); out.push(x); }
  }
  return out;
};

export default function news(state = initial, action) {
  switch (action.type) {
    case T.NEWS_RESET: return initial;

    case T.NEWS_SET_FILTERS:
      return { ...state, filters: { ...state.filters, ...action.payload } };

    case T.NEWS_FETCH_START:
      return { ...state, loading: true, error: null };

    case T.NEWS_FETCH_SUCCESS: {
      const items = action.payload.items || [];
      const nextCursor = action.payload.nextCursor || null;
      if (action.meta?.append) {
        return { ...state, loading:false, error:null, items: mergeUniqueById(state.items, items), nextCursor };
      }
      return { ...state, loading:false, error:null, items, nextCursor };
    }

    case T.NEWS_FETCH_ERROR:
      return { ...state, loading:false, error: action.error };

    case T.NEWS_CREATE_SUCCESS:
      return { ...state, items: [action.payload, ...state.items] };

    case T.NEWS_UPDATE_SUCCESS:
      return { ...state, items: state.items.map(x => x._id === action.payload._id ? action.payload : x) };

    case T.NEWS_DELETE_SUCCESS:
    case T.NEWS_DELETE_SOCKET:
      return { ...state, items: state.items.filter(x => x._id !== (action.payload?._id || action.payload)) };

    case T.NEWS_MARK_READ:
      return { ...state, items: state.items.map(x => x._id === action.payload ? { ...x, isRead:true } : x) };

    case T.NEWS_TOGGLE_PIN_LOCAL:
      return { ...state, items: state.items.map(x => x._id === action.payload ? { ...x, pinned: !x.pinned } : x) };

    default: return state;
  }
}
